<template>
    <div class="modal-overlay" @click="$emit('close')">
        <div class="modal p-5"  ref="myBtn" @click="$emit('close')">
           
           
            <img v-if="title === 'Delete'" src="../../assets/images/Group_175745.png" class="modalIcon" alt="">
            <img v-if="title === 'Success'" src="../../assets/images/Groupsuccess.png" class="modalIcon" alt="">
            <div style="padding-top: 30px; display: flex; flex-direction: column; gap: 1rem;" >

                
                <p style="font-size: 40px; font-weight: bold; color:#37A6A2; margin: 0; padding: 0;line-height: 39px; " >{{ title }}</p>
                <p class="cssMessage">{{message}}</p>
                <div class="d-flex  " style="width: 100%; justify-content: space-between;">
                    <button class="confirm-btn" @click="confirmHandler">{{confirmBtn}}</button>
                    <button class="cancle-btn" @click="cancleHandler">{{cancleBtn}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // import {onMounted} from "vue";
    // import mitt from 'mitt';
    // const emitter = mitt();
    export default {
        name:'confirmation-component',
        props: ['cancleBtn', 'confirmBtn', 'message', 'title'],
        data(){
            return {
                state: false
            }
        },
        methods:{
            confirmHandler(){
                // this.state = true;
                // this.$refs?.myBtn?.click();
            this.$emit('close-modal', true)
            },
            cancleHandler(){
                // this.state = false;
                // this.$refs?.myBtn?.click()

                this.$emit('close-modal', false)
            }
        }

    }
</script>

<style scoped>

    .cssMessage{
        color: var(--text-color-in-Confirm-immed);
        margin: 0 !important;
        padding: 0 !important;
    }

    .modal-overlay {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        background-color: #000;
        z-index: 100;
    }

    .modal {
        position: relative !important;
        text-align: center;
        display: flex !important;
        flex-direction: column;
        gap: 1rem;
        justify-content: center;
        align-content: center;
        align-items: center;
       overflow: visible;
        background-color: var(--background-color-input-create);
        height: 240px;
        border-radius: 20px;
        margin: auto;
        width: 27%;
    }


    h6 {
        font-weight: 500;
        font-size: 28px;
        margin: 20px 0;
    }

    p {
        font-size: 22px;
        margin: 30px 0;
        color: #FFF;
    }

    button {
        width: 150px;
        height: 50px;
        color: white;
        font-size: 18px;
        border-radius: 8px;
        font-weight: 600;
    }
.modalIcon{
    position: absolute;
    top: -70px;
}
    .confirm-btn{
        background-color: var(--btn-bg-color);
        border: 1px solid transparent;
    }
    .cancle-btn{
        background-color: white;
        color: #003A52;
        border: none;
    }
</style>